import React, { forwardRef, useContext, useEffect, useState } from 'react'
import { 
    Container,
    OptionDiv,
    OptionImg,
    OptionText
 } from './style'
import look from '../../../../../assets/certificates/AddParameter/look-into.svg'
import pencil from '../../../../../assets/certificates/AddParameter/pencil.svg'
import trash from '../../../../../assets/certificates/AddParameter/trash.svg'
import ParametersContext from '../../../../../contexts/ParametersContext'
import ModalContext from '../../../../../contexts/ModalContext'

interface OptionsDropdownProps {
    index: number
    ref: HTMLDivElement
    onChange: () => void
}

const OptionsDropdown = React.forwardRef<HTMLDivElement, OptionsDropdownProps>((props, forwardRef) => {
    const { structures, setStructures, setEditStructureIndex } = useContext(ParametersContext)
    const { setModalActive, setModalSection } = useContext(ModalContext)

    const EditClick = () => {
        setEditStructureIndex(props.index)
        setModalActive(true)
        setModalSection('editParamStructure')
        props.onChange()
    }

    const DeleteClick = () =>{
        const newStructures = [...structures]
        newStructures.splice(props.index, 1)
        setStructures(newStructures)
        props.onChange()
    }

    return (
        <Container ref={forwardRef}>
            <OptionDiv>
                <OptionImg src={look} alt='Look icon'/>
                <OptionText>Visualizar</OptionText>
            </OptionDiv>
            <OptionDiv onClick={() => EditClick()}>
                <OptionImg src={pencil} alt='Look icon'/>
                <OptionText>Editar</OptionText>
            </OptionDiv>
            <OptionDiv onClick={() => DeleteClick()}>
                <OptionImg src={trash} alt='Look icon'/>
                <OptionText>Excluir</OptionText>
            </OptionDiv>
        </Container>
    )
})

OptionsDropdown.displayName = 'OptionsDropdown'

export default OptionsDropdown